import Header from '@components/Header';
import Loading from '@components/Loading';
import { PaymentErrorType } from '@models/error';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import usePaymentFailed from './hooks/usePaymentFailed';

interface Params {
    type: PaymentErrorType;
    payload: string;
}

const PaymentFailedActivity : ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  usePaymentFailed(params);
  return (
        <AppScreen>
            <Header title='결제 실패' />
            <Loading/>
        </AppScreen>
  );
};

export default PaymentFailedActivity;
